import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../api';
import { setToken, setUser } from '../storage';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const r = await login(email, password);
      setToken(r.token);
      setUser({ id: r.user.id, email: r.user.email });
      navigate('/');
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth">
      <h1>记住</h1>
      <h2>登录</h2>
      <form onSubmit={submit}>
        <input type="email" placeholder="邮箱" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="密码" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
        {error && <div className="error">{error}</div>}
        <button type="submit" disabled={loading}>{loading ? '登录中…' : '登录'}</button>
        <Link to="/register">没有账号?注册</Link>
      </form>
    </div>
  );
}
